export const white = '#FFFFFF';

export const grey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
};

export const black = '#000000';

export const blue = '#0767DB';

export const green = '#45B880';

export const orange = '#FFB822';

export const red = '#ED4740';

export const primary = {
  main: blue,
  light: '#F6F9FD',
  dark: '#0B48A0',
};

// CHART.JS COLOURS

export const PURPLE_CHART_BACKGROUND = 'rgba(153, 102, 255, 0.2)';
export const PURPLE_CHART_BORDER = 'rgba(153, 102, 255, 1)';
export const GREEN_CHART_BACKGROUND = 'rgba(75, 192, 192, 0.2)';
export const GREEN_CHART_BORDER = 'rgba(75, 192, 192, 1)';
export const ORANGE_CHART_BACKGROUND = 'rgba(255, 159, 64, 0.2)';
export const ORANGE_CHART_BORDER = 'rgba(255, 159, 64, 1)';
export const RED_CHART_BACKGROUND = 'rgba(255, 99, 132, 0.2)';
export const RED_CHART_BORDER = 'rgba(255, 99, 132, 1)';
export const BLUE_CHART_BACKGROUND = 'rgba(54, 162, 235, 0.2)';
export const BLUE_CHART_BORDER = 'rgba(54, 162, 235, 1)';

export const INVISIBLE_CHART_COLOR = 'rgba(255, 255, 255, 0)';
